module.exports = __webpack_public_path__ + "static/media/Borg117.8920bf33.jpg";